var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { isValidElement } from 'react';
import { Tooltip } from 'flowbite-react';








const truncateText = (
text,
maxLength,
ellipsisPosition) =>
{
  if (text.length <= maxLength) return [text, ''];

  if (ellipsisPosition === 'end') {
    return [text.slice(0, maxLength).trim(), ''];
  }

  const start = text.slice(0, Math.floor(maxLength / 2)).trim();
  const end = text.slice(-Math.floor(maxLength / 2)).trim();
  return [start, end];
};

const getTextContent = (node) => {
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }

  if (Array.isArray(node)) return node.map((child) => getTextContent(child)).join('');

  if (/*#__PURE__*/isValidElement(node)) {
    const { children } = node.props;
    if (Array.isArray(children)) {
      const texts = children.map((child) => getTextContent(child));
      return texts.join('');
    }
    return getTextContent(children);
  }

  return '';
};

const getClassName = (node) => {
  if (/*#__PURE__*/isValidElement(node)) {
    return node.props.className || '';
  }
  return '';
};

const Truncate = ({
  children,
  maxLength = 40,
  tooltipClassname,
  ellipsisPosition = 'end'
}) => {
  const text = getTextContent(children);
  const childClassName = getClassName(children);
  const shouldEllipsize = text.length > maxLength;
  const [startText, endText] = truncateText(text, maxLength, ellipsisPosition);
  if (!shouldEllipsize) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  if (ellipsisPosition === 'end') {
    return (/*#__PURE__*/
      _jsx("span", {}, void 0, /*#__PURE__*/
      _jsx("span", { className: childClassName }, void 0, startText), /*#__PURE__*/
      _jsx("span", { className: "inline-flex" }, void 0, /*#__PURE__*/
      _jsx(Tooltip, {
        content: /*#__PURE__*/_jsx("span", { className: tooltipClassname }, void 0, text),
        arrow: true,
        animation: "duration-100"
        // eslint-disable-next-line react/style-prop-object
        , style: "light",
        className: "shadow-xl" }, void 0, /*#__PURE__*/

      _jsx("span", { className: `pointer-events-auto cursor-pointer px-1 ${childClassName}` }, void 0, "...")
      )
      )
      ));

  }

  return (/*#__PURE__*/
    _jsx("span", {}, void 0, /*#__PURE__*/
    _jsx("span", { className: childClassName }, void 0, startText), /*#__PURE__*/

    _jsx("span", { className: "inline-flex" }, void 0, /*#__PURE__*/
    _jsx(Tooltip, {
      content: /*#__PURE__*/_jsx("span", { className: tooltipClassname }, void 0, text),
      arrow: true,
      animation: "duration-100"
      // eslint-disable-next-line react/style-prop-object
      , style: "light",
      className: "shadow-xl" }, void 0, /*#__PURE__*/

    _jsx("span", { className: `pointer-events-auto cursor-pointer px-2 font-bold ${childClassName}` }, void 0, "[...]"

    )
    )
    ), /*#__PURE__*/

    _jsx("span", { className: childClassName }, void 0, endText)
    ));

};

export { Truncate };